import { Field, Form } from "react-final-form";
import React, { Component } from "react";

import Button from "Components/Button";
import { Fonts } from "Themes";
import FormInput from "Components/FormInput/FormInput";
import FormTextArea from "Components/FormTextArea";
import LinksList from "Components/LinksList";
import ProjectImages from "Components/ProjectImages";
import SideProject from "Components/SideProject";
import styled from "styled-components";
import styles from "./styles.module.scss";

const FieldLabel = styled.label`
  font-weight: bold;
  widht: 20%;
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
`;

const validate = (values) => {
  const errors = {};
  if (!values.projectName) {
    errors.projectName = "Required";
  }
  if (!values.projectDescription) {
    errors.projectDescription = "Required";
  }
  return errors;
};

class EditProjectForm extends Component {
  render() {
    const {
      handleSubmit,
      updateError,
      projectDetails,
      projectImages,
      editAvatar,
      removeProjectImage,
      addProjectImages,
      addProjectResource,
      deleteProject,
      fetching
    } = this.props;
    const { projectName, projectDescription, projectLinks } = projectDetails;
    return (
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        initialValues={{
          projectName,
          projectDescription,
        }}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <h1 style={Fonts.headerFont}>Editing {projectName}</h1>
            <div className={styles.detailContainer}>
              <div className={styles.titleContainer}>
                <div className={styles.field}>
                  <FieldLabel>Project Name</FieldLabel>
                  <Field
                    name={"projectName"}
                    render={(props) => {
                      return <FormInput {...props} placeholder={projectName} />;
                    }}
                  />
                </div>
                <div className={styles.field}>
                  <FieldLabel>Project Description</FieldLabel>
                  <Field
                    name={"projectDescription"}
                    render={(props) => {
                      return (
                        <FormTextArea
                          {...props}
                          placeholder={projectDescription}
                        />
                      );
                    }}
                  />
                </div>
              </div>
              <div className={styles.avatarContainer}>
                <SideProject onClick={editAvatar} project={projectDetails} />
              </div>
            </div>

            <div className={styles.linksContainer}>
              <LinksList
                editable
                projectResources={projectLinks}
                addOnClick={() => addProjectResource()}
                customLinkImage={projectDetails.projectAvatar}
              />
            </div>
            <div className={styles.imagesContainer}>
              <ProjectImages
                editable
                projectImages={projectImages}
                onRemoveClick={(id) => removeProjectImage(id)}
                onAddClick={() => addProjectImages()}
                onImageClick={() => {}}
              />
            </div>
              <div className={styles.buttonContainer}>
              <Button style={{ marginRight: 20 }} type={"submit"} fetching={fetching}>
                  Update Project Details
              </Button>
              <Button onClick={deleteProject} type={"button"} style={{ marginLeft: 20 }}>Delete project</Button>
              {updateError && <div style={{ color: "red" }}>{updateError}</div>}
            </div>
          </form>
        )}
      />
    );
  }
}

export default EditProjectForm;
